"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardInner = void 0;
exports.default = QuickLearnModalInnerCard;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _image = require("@site/pattern-library-core/image");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _base = require("@site/pattern-library-utils/base.functions");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardInner = exports.CardInner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardInner",
  class: "pl-c1kpgt0p"
});
const Image = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "Image",
  class: "pl-i1cxhx1v"
});
function QuickLearnModalInnerCard({
  item: {
    heading,
    devalueCopy = false,
    description,
    partial,
    image
  },
  layoutClass = 'default'
}) {
  const hasImage = image?.url ? 'has-image' : 'no-image';
  const innerHeading = (0, _react.useMemo)(() => devalueCopy ? /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 1,
    className: "card-heading",
    text: /*#__PURE__*/_react.default.createElement("strong", null, heading)
  }) : /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "title",
    className: "card-heading",
    text: heading
  }), [heading, devalueCopy]);
  return /*#__PURE__*/_react.default.createElement(CardInner, {
    "data-cy": "card-inner",
    className: `${layoutClass} ${hasImage}`,
    "data-partial": partial
  }, innerHeading, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    text: description
  }), image?.url && /*#__PURE__*/_react.default.createElement(Image, {
    dataCy: "modal-card-image",
    url: image?.url,
    altText: image?.altText || 'text',
    height: image?.height,
    width: image?.width
  }));
}
QuickLearnModalInnerCard.propTypes = {
  item: _propTypes.default.shape({
    heading: _propTypes.default.string,
    devalueCopy: _propTypes.default.bool,
    description: _propTypes.default.string,
    partial: _propTypes.default.string,
    image: _propTypes.default.shape({
      url: _propTypes.default.string,
      altText: _propTypes.default.string,
      height: _propTypes.default.number,
      width: _propTypes.default.number
    })
  }).isRequired,
  layoutClass: _propTypes.default.oneOf(['default', 'reverse', 'dual'])
};